import isUndefined from 'lodash-es/isUndefined';

/**
 * Determine if Safari 14 browsers support Intl.DisplayNames API.
 * At the time of this commit, we are supporting MacOS Safari 14.1 and iOS Safari 14.5, however iOS Safari supports starts from 14.5 doesn't have support for Intl.DisplayNames
 * @param userAgent request user agent
 * @returns boolean indicating if Intl.DisplayNames API is supported
 */
export function shouldAddSupportForIntlDisplayNames(userAgent?: string): boolean {
    if (!userAgent) {
        return false;
    }
    const needsDesktopSupport = isSafariMacOSGreaterOrEqualThan(userAgent, 14, 1);
    const needsMobileSupport = isSafariIosGreaterOrEqualThan(userAgent, 14, 5);

    return (
        (!isUndefined(needsDesktopSupport) && !needsDesktopSupport) ||
        (!isUndefined(needsMobileSupport) && !needsMobileSupport)
    );
}

export function isSafariMacOSGreaterOrEqualThan(
    userAgent: string,
    majorVersion: number,
    minorVersion: number,
): boolean | undefined {
    const regex = new RegExp(`Macintosh.*?OS\\sX.*?Version/${majorVersion}.(\\d+)`);

    const matches = regex.exec(userAgent)?.reverse();

    if (matches?.length) {
        return parseInt(matches[0], 10) >= minorVersion;
    }

    return undefined;
}

export function isSafariIosGreaterOrEqualThan(
    userAgent: string,
    majorVersion: number,
    minorVersion: number,
): boolean | undefined {
    const regex = new RegExp(`[iPhone|iPad].*?OS.*?${majorVersion}_(\\d+)`);

    const matches = regex.exec(userAgent)?.reverse();

    if (matches?.length) {
        return parseInt(matches[0], 10) >= minorVersion;
    }

    return undefined;
}
